import { useEffect, useState, useRef, useCallback } from "react";

import { getBlockId } from "../../../../utils/forms/form.fields.utils";

import FullscreenGallery from "./Gallery/FullScreenGallery";
import ThumbnailGallery from "./Gallery/ThumbnailGallery";

const isOdd = (v) => {
	return v % 2;
};

const createMasonry = () => {
	const thumbnailGallery = document.getElementsByClassName("thumbnailGallery")[0];
	const images = thumbnailGallery.getElementsByClassName("item");
	thumbnailGallery.style.width = "10000px";

	// thumbnailGallery.removeEventListener('wheel', );

	let topLeft = 0;
	let bottomLeft = 0;
	let firstImgFull = false;
	const gap = 0;
	for (let i = 0; i < images.length; i++) {
		const imgHolder = images[i];
		const imgCount = i + 1;
		if (imgCount === 1) {
			imgHolder.style.left = 0;
			imgHolder.style.top = 0;
			topLeft += imgHolder.offsetWidth;
			if (imgHolder.dataset.size === "two" && window.innerWidth > 600) {
				firstImgFull = true;
				bottomLeft += imgHolder.offsetWidth;
			}
		} else if (imgCount === 2 && !firstImgFull) {
			// imgHolder.style.borderLeft = 0; //missaligns on resize and mobile
			imgHolder.style.left = `${bottomLeft}px`;
			imgHolder.style.bottom = 0;
			bottomLeft += imgHolder.offsetWidth;
		} else if (isOdd(imgCount) === 0 && firstImgFull) {
			imgHolder.style.left = `${topLeft}px`;
			imgHolder.style.top = 0;
			topLeft += imgHolder.offsetWidth + gap;
		} else if (isOdd(imgCount) === 1 && firstImgFull) {
			imgHolder.style.left = `${bottomLeft}px`;
			imgHolder.style.bottom = 0;
			bottomLeft += imgHolder.offsetWidth + gap;
		} else if (isOdd(imgCount) === 1) {
			imgHolder.style.left = `${topLeft}px`;
			// imgHolder.style.top = 0; // breaks responsiveness
			topLeft += imgHolder.offsetWidth + gap;
		} else if (isOdd(imgCount) === 0) {
			imgHolder.style.left = `${bottomLeft}px`;
			imgHolder.style.bottom = 0;
			bottomLeft += imgHolder.offsetWidth + gap;
		}
	}

	thumbnailGallery.style.width =
		topLeft > bottomLeft ? `${topLeft}px` : `${bottomLeft}px`;

	return { topLeft, bottomLeft };
};

const GalleryComponent = (props) => {
	const { block } = props;

	const [openGallery, setOpenGallery] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0);
	const [prevIndex, setPrevIndex] = useState(-1);
	const [triggerSource, setTriggerSource] = useState('thumbnail');

	const [videoPlay, setVideoPlay] = useState(-1);

	const videoRefs = useRef([]);

	useEffect(() => {
		createMasonry();
	}, []);

	useEffect(() => {
		window.addEventListener("resize", createMasonry);
		return () => {
			window.removeEventListener("resize", createMasonry);
		};
	}, []);

	useEffect(() => {
		if (videoRefs && videoRefs.current) {
			videoRefs.current.forEach((el) => {
				if (videoPlay == el.videoIndex && videoPlay != -1) {
					if (el.videoElement.seekable) { // HTML5 video
						el.videoElement.play();
					}
				} else {
					if (el.videoElement.seekable) { // HTML5 video
						el.videoElement.pause();
					}
				}
			});
		}
	}, [videoPlay]);

	const addVideoRefs = useCallback((videoElement, videoIndex) => {
		if (videoElement && !videoRefs.current.includes(videoElement)) {
			videoRefs.current.push({ videoElement, videoIndex });
		}
	}, [videoRefs.current]);

	const toggleScroll = useCallback((isGalleryOpen) => {
		let gallery = document.getElementsByClassName("galleryHolder")[0];
		{ isGalleryOpen ? gallery.style.overflow = "auto" : gallery.style.overflow = "visible" }	// IE knows visible but not initial				
	}, []);

	const toggleGallery = useCallback((i) => {
		setTriggerSource('thumbnail');
		setOpenGallery(true);

		if (i >= 0) {
			setPrevIndex(activeIndex);
			setActiveIndex(i);
		}

		setVideoPlay(i);
		toggleScroll(false);
	}, [activeIndex]);

	const prevImage = useCallback(() => {
		setTriggerSource('gallery');
		setPrevIndex(activeIndex);
		let active = activeIndex - 1;
		if (active < 0) {
			active = 0;
		}
		setActiveIndex(active);
		setVideoPlay(active);
	}, [activeIndex]);

	const nextImage = useCallback(() => {
		setTriggerSource('gallery');
		setPrevIndex(activeIndex);
		let active = activeIndex + 1;
		if (active > block.data.children.length - 1) {
			active = block.data.children.length - 1;
		}
		setActiveIndex(active);
		setVideoPlay(active);
	}, [activeIndex]);

	const scrollerStyle = "scrollColour" in block && block.scrollColour === 'grey' ? 'grey-scroll ' : 'red-scroll';

	return (
		<div
			className={`galleryHolder ${scrollerStyle}`}
			id={getBlockId(block)}
		>
			<ThumbnailGallery toggleGallery={toggleGallery} block={block} />
			<FullscreenGallery
				setOpenGallery={setOpenGallery}
				openGallery={openGallery}
				addVideoRefs={addVideoRefs}
				nextImage={nextImage}
				prevImage={prevImage}
				activeIndex={activeIndex}
				block={block}
				toggleGallery={toggleGallery}
				toggleScroll={toggleScroll}
				prevIndex={prevIndex}
				triggerSource={triggerSource}
			/>
		</div>
	);
};

export default GalleryComponent;
